import React from "react";
import { Container, Navbar, Nav } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { StorageServices } from "../../../services";
import "./navsidestyle.css";
import Offcanvas from "react-bootstrap/Offcanvas";
import { FormattedMessage } from "react-intl";
import { LanguageContext } from "../../../../contexts/LanguageContext";

export default class Navapp extends React.Component<any, any> {
  static contextType = LanguageContext;

  constructor(props: any) {
    super(props);

    this.state = {
      user: StorageServices.GetCookieUser(),
      showMenu: false,
      showOffcanvas: false,
      isHelpDropdownOpen: false,
    };
  }

  toggleHelpDropdown = () => {
    this.setState((prevState: any) => ({
      isHelpDropdownOpen: !prevState.isHelpDropdownOpen,
    }));
  };

  toggleDropdown = () => {
    this.setState((prevState: any) => ({
      isDropdownOpen: !prevState.isDropdownOpen,
    }));
  };

  toggleOffcanvas() {
    this.setState((prevState: any) => ({
      showOffcanvas: !prevState.showOffcanvas,
    }));
  }

  onClickMenuBars() {
    try {
      this.setState({ showMenu: !this.state.showMenu });
      this.props.onClickMenuAside(this.state.showMenu);
    } catch (error) {
      console.log(error);
    }
  }

  onLogout() {
    try {
      StorageServices.FlushCookie();
      document.location.pathname = "/";
    } catch (error) {
      console.log(error);
    }
  }

  render() {
    const { readysizelocale, changeLanguage } = this.context;
    return (
      <>
        <Nav
          defaultActiveKey="/fiprenda"
          className={
            this.state.showMenu
              ? "flex-column nav-side"
              : "flex-column nav-side colapse"
          }
        >
          <div
            className="nav-side-content-item"
            onClick={() => this.toggleOffcanvas()}
          >
            <FontAwesomeIcon
              icon="bars"
              className="ms-3 mt-4"
            ></FontAwesomeIcon>
          </div>
          <Offcanvas
            show={this.state.showOffcanvas}
            onHide={() => this.toggleOffcanvas()}
            backdrop={false}
            className="offcanvas-main-container"
          >
            <div className="navapp-main-container-parent">
              <div className="navapp-main-container">
                <Nav className="me-auto">
                  <Nav.Link href="/readysize">
                    <img
                      src="/img/readysizelogo.png"
                      alt="Logo-ReadySize"
                      width="130"
                      className="d-inline-block align-top navapp-fitprenda-logo"
                    />
                  </Nav.Link>
                </Nav>
              </div>
              <Offcanvas.Header
                className="navapp-offcanva-x-button"
                closeButton
              ></Offcanvas.Header>
            </div>
            <Offcanvas.Body>
              <Nav className=" flex-grow-1 offcanva-navapp-main-container">
                <div>
                  <hr className="nav-side-divider-offcanvas" />
                  <Nav.Item className="custom-navlink-navapp">
                    <Nav.Link href="/readysize">
                      <FontAwesomeIcon
                        icon="home"
                        className="nav-side-icon"
                      ></FontAwesomeIcon>
                      <span
                        className={
                          this.state.showMenu
                            ? "nav-side-icon-text"
                            : "nav-side-icon-text"
                        }
                      >
                        <FormattedMessage id={"ready-size-start"} />
                      </span>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="custom-navlink-navapp">
                    <Nav.Link href="/readysize/charts">
                      <FontAwesomeIcon
                        icon="chart-line"
                        className="nav-side-icon"
                      ></FontAwesomeIcon>
                      <span
                        className={
                          this.state.showMenu
                            ? "nav-side-icon-text"
                            : "nav-side-icon-text"
                        }
                      >
                        <FormattedMessage id={"ready-size-statistics"} />
                      </span>
                    </Nav.Link>
                  </Nav.Item>
                  <hr className="nav-side-divider-offcanvas" />
                  <Nav.Item className="custom-navlink-navapp">
                    <Nav.Link href="/readysize/tools">
                      <FontAwesomeIcon
                        icon="cog"
                        className="nav-side-icon"
                      ></FontAwesomeIcon>
                      <span
                        className={
                          this.state.showMenu
                            ? "nav-side-icon-text"
                            : "nav-side-icon-text"
                        }
                      >
                        <FormattedMessage id={"side-nav-tools"} />
                      </span>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="custom-navlink-navapp">
                    <Nav.Link href="/readysize/sizes-guides">
                      <FontAwesomeIcon
                        icon="ruler"
                        className="nav-side-icon"
                      ></FontAwesomeIcon>
                      <span
                        className={
                          this.state.showMenu
                            ? "nav-side-icon-text"
                            : "nav-side-icon-text"
                        }
                      >
                        <FormattedMessage id={"ready-size-sizes-guides"} />
                      </span>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="custom-navlink-navapp">
                    <Nav.Link href="/readysize/products">
                      <FontAwesomeIcon
                        icon="tshirt"
                        className="nav-side-icon"
                      ></FontAwesomeIcon>
                      <span
                        className={
                          this.state.showMenu
                            ? "nav-side-icon-text"
                            : "nav-side-icon-text"
                        }
                      >
                        <FormattedMessage id={"ready-size-products"} />
                      </span>
                    </Nav.Link>
                  </Nav.Item>
                  {this.state.user.PlatformId === 200 && (
                    <Nav.Item className="custom-navlink-navapp">
                      <Nav.Link href="/readysize/mercado-shops">
                        <FontAwesomeIcon
                          icon="handshake"
                          className="nav-side-icon"
                        ></FontAwesomeIcon>
                        <span
                          className={
                            this.state.showMenu
                              ? "nav-side-icon-text"
                              : "nav-side-icon-text"
                          }
                        >
                          <FormattedMessage id={"navapp-mercadoshops"} />
                        </span>
                      </Nav.Link>
                    </Nav.Item>
                  )}
                  {this.state.user.PlatformId === 2 && (
                    <Nav.Item className="custom-navlink-navapp">
                      <Nav.Link href="/readysize/tienda-nube">
                        <FontAwesomeIcon
                          icon="cloud"
                          className="nav-side-icon"
                        ></FontAwesomeIcon>
                        <span
                          className={
                            this.state.showMenu
                              ? "nav-side-icon-text"
                              : "nav-side-icon-text"
                          }
                        >
                          <FormattedMessage id={"navapp-tiendanube"} />
                        </span>
                      </Nav.Link>
                    </Nav.Item>
                  )}
                </div>
                <div className="navapp-exit-container">
                  <hr className="nav-side-divider-offcanvas-bottom" />
                  <Nav.Item className="custom-navlink-navapp">
                    <Nav.Link href="" onClick={() => this.onLogout()}>
                      <FontAwesomeIcon
                        icon="sign-out-alt"
                        className="nav-side-icon"
                      ></FontAwesomeIcon>
                      <span
                        className={
                          this.state.showMenu
                            ? "nav-side-icon-text"
                            : "nav-side-icon-text "
                        }
                      >
                        <FormattedMessage id={"side-nav-sign-out"} />
                      </span>
                    </Nav.Link>
                  </Nav.Item>
                </div>
              </Nav>
            </Offcanvas.Body>
          </Offcanvas>
          <hr className="nav-side-divider" />
          <Nav.Item>
            <Nav.Link href="/readysize">
              <FontAwesomeIcon
                icon="home"
                className="nav-side-icon active"
              ></FontAwesomeIcon>
              <span
                className={
                  this.state.showMenu
                    ? "nav-side-icon-text active"
                    : "nav-side-icon-text active colapse"
                }
              >
                Inicio
              </span>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="/readysize/charts">
              <FontAwesomeIcon
                icon="chart-line"
                className="nav-side-icon"
              ></FontAwesomeIcon>
              <span
                className={
                  this.state.showMenu
                    ? "nav-side-icon-text"
                    : "nav-side-icon-text colapse"
                }
              >
                Estadísticas
              </span>
            </Nav.Link>
          </Nav.Item>
          <hr className="nav-side-divider" />
          <div
            className={
              this.state.showMenu
                ? "nav-side-section"
                : "nav-side-section colapse"
            }
          >
            Administrar
          </div>
          <Nav.Item>
            <Nav.Link href="/readysize/tools">
              <FontAwesomeIcon
                icon="cog"
                className="nav-side-icon"
              ></FontAwesomeIcon>
              <span
                className={
                  this.state.showMenu
                    ? "nav-side-icon-text"
                    : "nav-side-icon-text colapse"
                }
              >
                Herramientas
              </span>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="/readysize/sizes-guides">
              <FontAwesomeIcon
                icon="ruler"
                className="nav-side-icon"
              ></FontAwesomeIcon>
              <span
                className={
                  this.state.showMenu
                    ? "nav-side-icon-text"
                    : "nav-side-icon-text colapse"
                }
              >
                Guías de talles
              </span>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="/readysize/products">
              <FontAwesomeIcon
                icon="tshirt"
                className="nav-side-icon"
              ></FontAwesomeIcon>
              <span
                className={
                  this.state.showMenu
                    ? "nav-side-icon-text"
                    : "nav-side-icon-text colapse"
                }
              >
                Productos
              </span>
            </Nav.Link>
          </Nav.Item>
          {this.state.user.PlatformId === 200 && (
            <Nav.Item className="custom-navlink-navapp">
              <Nav.Link href="/readysize/mercado-shops">
                <FontAwesomeIcon
                  icon="handshake"
                  className="nav-side-icon"
                ></FontAwesomeIcon>
                <span
                  className={
                    this.state.showMenu
                      ? "nav-side-icon-text"
                      : "nav-side-icon-text"
                  }
                >
                  {/* <FormattedMessage id={"navapp-mercadoshops"} />  */}
                </span>
              </Nav.Link>
            </Nav.Item>
          )}
          {this.state.user.PlatformId === 2 && (
            <Nav.Item className="custom-navlink-navapp">
              <Nav.Link href="/readysize/tienda-nube">
                <FontAwesomeIcon
                  icon="cloud"
                  className="nav-side-icon"
                ></FontAwesomeIcon>
                <span
                  className={
                    this.state.showMenu
                      ? "nav-side-icon-text"
                      : "nav-side-icon-text"
                  }
                >
                  {/* <FormattedMessage id={"navapp-tiendanube"} /> */}
                </span>
              </Nav.Link>
            </Nav.Item>
          )}
          <hr className="nav-side-divider-bottom" />
          <Nav.Item>
            <Nav.Link href="" onClick={() => this.onLogout()}>
              <FontAwesomeIcon
                icon="sign-out-alt"
                className="nav-side-icon"
              ></FontAwesomeIcon>
              <span
                className={
                  this.state.showMenu
                    ? "nav-side-icon-text"
                    : "nav-side-icon-text colapse"
                }
              >
                Salir
              </span>
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <Navbar
          className={
            this.state.showMenu
              ? "navbar-fitprenda"
              : "navbar-fitprenda colapse"
          }
          fixed="top"
          bg="white"
        >
          <Container className="navapp-main-container">
            <Nav className="me-auto">
              <Nav.Link href="/readysize">
                <img
                  src="/img/readysizelogo.png"
                  alt="Logo-ReadySize"
                  width="130"
                  className="d-inline-block align-top"
                />
              </Nav.Link>
            </Nav>
            <Nav className="ms-auto">
              <Nav.Link href="/readysize">
                <FontAwesomeIcon
                  icon="bell"
                  className="nav-side-icon"
                ></FontAwesomeIcon>
                <span className="nav-side-icon-text">
                  <FormattedMessage id={"navapp-news"} />
                </span>
              </Nav.Link>
              <Nav.Item>
                <Nav.Link onClick={this.toggleHelpDropdown}>
                  <FontAwesomeIcon
                    icon="question-circle"
                    className="nav-side-icon"
                  ></FontAwesomeIcon>
                  <span className="nav-side-icon-text">
                    <FormattedMessage
                      id={"ready-size-help"}
                      defaultMessage="Ayuda"
                    />
                  </span>
                </Nav.Link>
                {this.state.isHelpDropdownOpen && (
                  <div className="dropdown-menu show">
                    {this.state.user.PlatformId === 200 ? (
                      <>
                        <a
                          className="dropdown-item"
                          href="mailto:mercadoshops@readysize.ai"
                        >
                          <FormattedMessage
                            id="login-contact-us"
                            defaultMessage="Contactanos"
                          />
                        </a>
                        <a
                          className="dropdown-item"
                          href="https://www.notion.so/a671d60604d746efa40d65cf2c53b601?v=0cede08b54554dcba0b626047bb15cc6"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          FAQ
                        </a>
                      </>
                    ) : this.state.user.PlatformId === 2 ? (
                      <>
                        <a
                          className="dropdown-item"
                          href="mailto:tiendanube@readysize.ai"
                        >
                          <FormattedMessage
                            id="login-contact-us"
                            defaultMessage="Contactanos"
                          />
                        </a>
                        <a
                          className="dropdown-item"
                          href="https://www.notion.so/2d64ec90108345b29361c9bde24edecb?v=f6043854380245d9b359d7f373467ba2"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          FAQ
                        </a>
                      </>
                    ) : (
                      <>
                        <a
                          className="dropdown-item"
                          href="mailto:hello@readysize.ai"
                        >
                          <FormattedMessage
                            id="login-contact"
                            defaultMessage="Contactanos"
                          />
                        </a>
                      </>
                    )}
                  </div>
                )}
              </Nav.Item>
              <Nav.Link href="/readysize">
                <FontAwesomeIcon
                  icon="user"
                  className="nav-side-icon"
                ></FontAwesomeIcon>
                <span className="nav-side-icon-text">
                  {this.state.user.Contract.Name}
                </span>
              </Nav.Link>
            </Nav>
            <div className="fitprenda-modal-close-lang-container">
              <div className="new-custom-dropdown">
                <div
                  className="new-selected-language"
                  onClick={this.toggleDropdown}
                >
                  {readysizelocale === "en" && (
                    <img
                      src={`/img/US.png`}
                      alt="gb-lang"
                      className="new-readysize-flag-img"
                    />
                  )}
                  {readysizelocale === "es" && (
                    <img
                      src={`/img/ES.png`}
                      alt="es-lang"
                      className="new-readysize-flag-img"
                    />
                  )}
                  {readysizelocale === "pt" && (
                    <img
                      src={`img/BR.png`}
                      alt="br-lang"
                      className="new-readysize-flag-img"
                    />
                  )}
                </div>
                {this.state.isDropdownOpen && (
                  <div className="new-dropdown-options">
                    <div onClick={() => changeLanguage("en")}>English</div>
                    <div onClick={() => changeLanguage("es")}>Español</div>
                    <div onClick={() => changeLanguage("pt")}>Português</div>
                  </div>
                )}
              </div>
            </div>
          </Container>
        </Navbar>
      </>
    );
  }
}
